<script setup>
import { ref, onMounted } from 'vue'
import { useAuthStore } from './stores/auth'
import AppMenu from '/src/components/menu/AppMenu.vue'
import TeamSidebar from '/src/components/menu/TeamSidebar.vue'
import FloatHub from '/src/components/float-hub/FloatHub.vue'

const authStore = useAuthStore()
const showSidebar = ref(false)

const toggleSidebar = () => {
  showSidebar.value = !showSidebar.value
}

// 在应用启动时验证用户状态
onMounted(async () => {
  if (localStorage.getItem('token')) {
    await authStore.verifyAuth()
  }
})
</script>

<template>
  <div class="h-screen flex flex-col">
    <!-- 认证路由 -->
    <template v-if="!$route.meta.requiresAuth">
      <router-view />
    </template>
    
    <!-- 主应用布局 -->
    <template v-else>
      <!-- /boards 路由使用 BoardSidebarView 布局（包含自己的sidebar） -->
      <template v-if="$route.path === '/boards'">
        <router-view />
      </template>
      
      <!-- /knowledge 路由使用全屏画布布局 -->
      <template v-else-if="$route.path.startsWith('/knowledge')">
        <div class="flex-1 flex flex-col">
          <AppMenu @toggle-sidebar="toggleSidebar" />
          <div class="flex-1 overflow-hidden">
            <router-view />
          </div>
        </div>
      </template>
      
      <!-- /teams 路由使用 TeamSidebar -->
      <template v-else-if="$route.path === '/teams'">
        <div class="flex-1 flex flex-col">
          <!-- 顶部导航菜单（全宽） -->
          <AppMenu @toggle-sidebar="toggleSidebar" />
          
          <!-- 侧边栏 + 主内容 -->
          <div class="flex flex-1 overflow-hidden">
            <TeamSidebar />
            <div class="flex-1 overflow-auto">
              <router-view :show-sidebar="showSidebar" @toggle-sidebar="toggleSidebar" />
            </div>
          </div>
        </div>
      </template>
      
      <!-- 其他路由（包括主页/看板页面）不显示sidebar -->
      <template v-else>
        <div class="flex-1 flex flex-col">
          <!-- 顶部导航菜单 -->
          <AppMenu @toggle-sidebar="toggleSidebar" />
          
          <!-- 主内容 -->
          <div class="flex-1 overflow-auto">
            <router-view :show-sidebar="showSidebar" @toggle-sidebar="toggleSidebar" />
          </div>
        </div>
      </template>
    </template>
    
    <!-- 功能枢纽悬浮球 -->
    <FloatHub />
    
    <!-- 版权声明 -->
    <footer class="bg-gradient-to-r from-primary-500 to-primary-600 text-white py-2 mt-auto">
      <div class="container mx-auto px-4 text-center">
        <p class="text-xs opacity-90">© {{ new Date().getFullYear() }} NullSignifier. All rights reserved.</p>
      </div>
    </footer>
  </div>
</template>
